export default {
    create_partnumber_create_title: "New Part Number",
    create_partnumber_edit_title: "Edit Part Number",
    create_partnumber_create_success_message: "The part number has been created",
    create_partnumber_update_success_message: "The part number has been edited",
    create_partnumber_manufacturer: "Manufacturer",
    create_partnumber_part_number: "Part Number",
    create_partnumber_device_model: "Device Model",
    create_partnumber_network: "Network",
}